"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdresseBase = _interopRequireDefault(require("./AdresseBase"));
var _RentalItem = _interopRequireDefault(require("./RentalItem"));
var _RentalPackage = _interopRequireDefault(require("./RentalPackage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The RentalBookingCreate model module.
 * @module model/RentalBookingCreate
 * @version 0.0.1
 */
class RentalBookingCreate {
  /**
   * Constructs a new <code>RentalBookingCreate</code>.
   * @alias module:model/RentalBookingCreate
   * @param von {Date} 
   * @param bis {Date} 
   * @param adresse {module:model/AdresseBase} 
   * @param veranstaltungsort {String} 
   * @param veranstaltungsthema {String} 
   * @param rechnungsadresse {String} 
   */
  constructor(von, bis, adresse, veranstaltungsort, veranstaltungsthema, rechnungsadresse) {
    RentalBookingCreate.initialize(this, von, bis, adresse, veranstaltungsort, veranstaltungsthema, rechnungsadresse);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, von, bis, adresse, veranstaltungsort, veranstaltungsthema, rechnungsadresse) {
    obj['von'] = von;
    obj['bis'] = bis;
    obj['adresse'] = adresse;
    obj['veranstaltungsort'] = veranstaltungsort;
    obj['veranstaltungsthema'] = veranstaltungsthema;
    obj['rechnungsadresse'] = rechnungsadresse;
  }

  /**
   * Constructs a <code>RentalBookingCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RentalBookingCreate} obj Optional instance to populate.
   * @return {module:model/RentalBookingCreate} The populated <code>RentalBookingCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RentalBookingCreate();
      if (data.hasOwnProperty('archived')) {
        obj['archived'] = _ApiClient.default.convertToType(data['archived'], 'Boolean');
      }
      if (data.hasOwnProperty('von')) {
        obj['von'] = _ApiClient.default.convertToType(data['von'], 'Date');
      }
      if (data.hasOwnProperty('bis')) {
        obj['bis'] = _ApiClient.default.convertToType(data['bis'], 'Date');
      }
      if (data.hasOwnProperty('adresse')) {
        obj['adresse'] = _AdresseBase.default.constructFromObject(data['adresse']);
      }
      if (data.hasOwnProperty('veranstaltungsort')) {
        obj['veranstaltungsort'] = _ApiClient.default.convertToType(data['veranstaltungsort'], 'String');
      }
      if (data.hasOwnProperty('veranstaltungsthema')) {
        obj['veranstaltungsthema'] = _ApiClient.default.convertToType(data['veranstaltungsthema'], 'String');
      }
      if (data.hasOwnProperty('rechnungsadresse')) {
        obj['rechnungsadresse'] = _ApiClient.default.convertToType(data['rechnungsadresse'], 'String');
      }
      if (data.hasOwnProperty('items')) {
        obj['items'] = _ApiClient.default.convertToType(data['items'], [_RentalItem.default]);
      }
      if (data.hasOwnProperty('packages')) {
        obj['packages'] = _ApiClient.default.convertToType(data['packages'], [_RentalPackage.default]);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>RentalBookingCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RentalBookingCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of RentalBookingCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // validate the optional field `adresse`
    if (data['adresse']) {
      // data not null
      _AdresseBase.default.validateJSON(data['adresse']);
    }
    // ensure the json data is a string
    if (data['veranstaltungsort'] && !(typeof data['veranstaltungsort'] === 'string' || data['veranstaltungsort'] instanceof String)) {
      throw new Error("Expected the field `veranstaltungsort` to be a primitive type in the JSON string but got " + data['veranstaltungsort']);
    }
    // ensure the json data is a string
    if (data['veranstaltungsthema'] && !(typeof data['veranstaltungsthema'] === 'string' || data['veranstaltungsthema'] instanceof String)) {
      throw new Error("Expected the field `veranstaltungsthema` to be a primitive type in the JSON string but got " + data['veranstaltungsthema']);
    }
    // ensure the json data is a string
    if (data['rechnungsadresse'] && !(typeof data['rechnungsadresse'] === 'string' || data['rechnungsadresse'] instanceof String)) {
      throw new Error("Expected the field `rechnungsadresse` to be a primitive type in the JSON string but got " + data['rechnungsadresse']);
    }
    if (data['items']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['items'])) {
        throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
      }
      // validate the optional field `items` (array)
      for (const item of data['items']) {
        _RentalItem.default.validateJSON(item);
      }
      ;
    }
    if (data['packages']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['packages'])) {
        throw new Error("Expected the field `packages` to be an array in the JSON data but got " + data['packages']);
      }
      // validate the optional field `packages` (array)
      for (const item of data['packages']) {
        _RentalPackage.default.validateJSON(item);
      }
      ;
    }
    return true;
  }
}
RentalBookingCreate.RequiredProperties = ["von", "bis", "adresse", "veranstaltungsort", "veranstaltungsthema", "rechnungsadresse"];

/**
 * @member {Boolean} archived
 * @default false
 */
RentalBookingCreate.prototype['archived'] = false;

/**
 * @member {Date} von
 */
RentalBookingCreate.prototype['von'] = undefined;

/**
 * @member {Date} bis
 */
RentalBookingCreate.prototype['bis'] = undefined;

/**
 * @member {module:model/AdresseBase} adresse
 */
RentalBookingCreate.prototype['adresse'] = undefined;

/**
 * @member {String} veranstaltungsort
 */
RentalBookingCreate.prototype['veranstaltungsort'] = undefined;

/**
 * @member {String} veranstaltungsthema
 */
RentalBookingCreate.prototype['veranstaltungsthema'] = undefined;

/**
 * @member {String} rechnungsadresse
 */
RentalBookingCreate.prototype['rechnungsadresse'] = undefined;

/**
 * @member {Array.<module:model/RentalItem>} items
 */
RentalBookingCreate.prototype['items'] = undefined;

/**
 * @member {Array.<module:model/RentalPackage>} packages
 */
RentalBookingCreate.prototype['packages'] = undefined;
var _default = exports.default = RentalBookingCreate;